export const API_CHART_ACTIVATIONS_PER_DAY = "/api/statistics/activations-per-day";